<template>
    <bita-modal
        id="portfolio-tech"
        :is-loading="isLoadingModal"
        :modal-lg="true"
        title="تکنولوژی به کار رفته"
        @close="reset()"
    >
        <div slot="body">
            <bita-form ref="form">
                <div slot="body">
                    <div
                        class="row"
                        v-for="(tech, index) in techs"
                        :key="index"
                    >
                        <div class="col-lg-9">
                            <div class="form-group">
                                <label>
                                    تکنولوژی
                                </label>
                                <input
                                    class="form-control"
                                    type="text"
                                    v-model="tech.description"
                                />
                            </div>
                        </div>
                        <div class="col-3 mt-4">
                            <div
                                class="btn btn-danger ml-1"
                                @click="removeTech(tech, index)"
                            >
                                حذف
                            </div>
                            <div
                                class="btn btn-success"
                                @click="addTech()"
                            >
                                افزودن
                            </div>
                        </div>
                    </div>
                    <div class="text-left">
                        <div
                            v-if="!techs.length > 0"
                            class="btn btn-success"
                            @click="addTech()"
                        >
                            افزودن
                        </div>
                    </div>
                </div>
            </bita-form>
        </div>
        <div slot="footer">
            <bita-bootbutton
                title="بروز رسانی"
                type="primary mb-3"
                icon="fas fa-save"
                btn-width="150px"
                @click.native="update"
                :disabled="isLoadingModal"
            />
        </div>
    </bita-modal>
</template>
<script>
import { portfolioApi } from "@/api/apiManagement";
export default {
    data() {
        return {
            colWidth: "col-lg-6",
            formData: {},
            techs: [],
            isLoadingModal: false,
        }
    },
    methods: {
        setInitialData(_data) {
            this.isLoadingModal = true;
            this.formData = _data;
            this.techs = this.formData.technology && this.formData.technology.length > 0 ? 
                this.serializeTech(this.formData.technology) : 
                [{ description: null }];
            this.isLoadingModal = false;
        },
        update() {
            this.$refs.form.validate()
                .then( (res) => {
                    if ( res ) {
                        this.isLoadingModal = true;
                        let data = { technology: this.techs };
                        portfolioApi.update(this.formData.id, data)
                            .then( (res) => {
                                this.$izitoast("success", "موفق!", res.data.message);
                                this.$toggleModal("#portfolio-tech");
                                this.$emit("load-data");
                            })
                            .finally( () => this.isLoadingModal = false );
                    }
                })
        },
        serializeTech(_tech) {
            let data = [];
            _tech.forEach((element,index) => {
                data[index] = {
                    description: element.description
                }
            });
            return data;
        },
        removeTech(_tech, _index) {
            this.$delete(this.techs, _index);
        },
        addTech() {
            this.techs.push({ description: "" });
        },
        reset() {
            this.formData = {};
            this.techs = [];
            this.$refs.form.reset();
        },
    }
}
</script>